import { useNavigate } from 'react-router-dom';
import { CAS } from '.';

export const CASResponse = () => {
  const navigate = useNavigate();
  const cas = CAS.init(window.location.search);
  const user = cas.getUser();
  navigate(`/users/${user.id}`);
  return <>Loading..</>
}